import { useState } from 'react'

import { HostedFormStep } from '@percent/product-nomination-form/app/HostedForm/HostedForm/HostedForm.types'
import { NavigationStackContext } from '../NavigationStackContext/NavigationStackContext'

import { NavigationStackContextControllerProps } from './NavigationStackContextController.types'

export const NavigationStackContextController = ({
  defaultValidationStep = HostedFormStep.INTRODUCTION,
  children,
}: NavigationStackContextControllerProps) => {
  const [validationStep, setValidationStep] = useState<HostedFormStep>(
    defaultValidationStep
  )
  const [navigationStack, setNavigationStack] = useState<HostedFormStep[]>([
    HostedFormStep.INTRODUCTION,
  ])

  const handleNext = (step: HostedFormStep) => {
    setNavigationStack(() => [...navigationStack, step])
    return setValidationStep(step)
  }

  const handleBack = () => {
    setNavigationStack(() => {
      const newStack = [...navigationStack]
      newStack.pop()
      setValidationStep(newStack[newStack.length - 1])

      return newStack
    })
  }

  return (
    <NavigationStackContext.Provider
      value={{ validationStep, handleNext, handleBack }}
    >
      {children}
    </NavigationStackContext.Provider>
  )
}
